import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Icon } from 'components';

// Styles
import style from './styles.pcss';

const cx = classNames.bind(style);

const DropdownOption = ({
  label,
  onClick,
  active,
}) => (
  <button
    className={cx('option-btn')}
    onClick={onClick}
    type="button"
  >
    <div className={cx('option-wrapper')}>
      {label && <div className={cx('label')}>{label}</div>}
      {active && (
      <div className={cx('check')}>
        <Icon name="check-icon" />
      </div>
      )}
    </div>
  </button>
);

DropdownOption.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  active: PropTypes.bool,
};

export { DropdownOption };
